import React from 'react';
import axios from 'axios';
import { user_token } from '../../../services/Auth';

//import da API
import { organizer } from './../../../services/api';
let apiOrganizer = new organizer();

var token = localStorage.getItem(user_token);

export default class GetUser extends React.Component {
  state = {
    paciente: []
  }

  componentDidMount() {
    //axios.get(`http://api-convida.herokuapp.com/user/${this.props.user_id}`, { headers: { 'x-access-token': token } })
    apiOrganizer.getUser(this.props.user_id)
      .then(res => {
        const paciente = res.data;
        this.setState({ paciente });
      })
  }

  render() {
    return (
      <ul>
        {this.state.paciente.map(details =>
          <>
            <p id="RI-Title-Cadastro-Paciente" >Nome do(a) Paciente</p><p>{details.name}</p>
            {details.user_type === "Paciente" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Paciente da instituição</p></> :
              details.user_type === "Funcionario" ? <> <p id="RI-Title-Cadastro-Paciente">Tipo de paciente:</p><p>Funcionário da instituição</p></> :
                null}
            <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento do Paciente</p><p>{details.birth}</p>
            <p id="RI-Title-Cadastro-Paciente" >CPF do Paciente</p><p>{details.cpf}</p>
          </>)}
      </ul>
    )
  }
}